import type { ListProductsParams } from '@amarantos/api-client'
import { ProductCategory } from '@amarantos/api-client'
import { z } from 'zod/v3'

export const productCategories = Object.values(ProductCategory)

export const categoryFilterValues = ['all', ...productCategories] as const

const baseProductsSearchSchema = z.object({
	productsPage: z.coerce.number().int().positive().default(1),
	productsPerPage: z.coerce.number().int().positive().max(100).default(10),
	productSearch: z.string().optional().default(''),
	productCategory: z.enum(categoryFilterValues).default('all'),
})

const productDrawerSearchStateSchema = z.union([
	z.object({
		productDrawerMode: z.literal('create'),
		productId: z.undefined().optional(),
	}),
	z.object({
		productDrawerMode: z.literal('edit'),
		productId: z.coerce.number().int().positive(),
	}),
	z.object({
		productDrawerMode: z.undefined().optional(),
		productId: z.undefined().optional(),
	}),
])

export const productsSearchSchema = baseProductsSearchSchema.and(productDrawerSearchStateSchema)

export type ProductsSearch = z.infer<typeof productsSearchSchema>

export function toListProductsParams(search: ProductsSearch, supplierId: number): ListProductsParams {
	return {
		page: search.productsPage,
		per_page: search.productsPerPage,
		search: search.productSearch || undefined,
		product_category: search.productCategory === 'all' ? undefined : (search.productCategory as ProductCategory),
		supplier_id: [supplierId],
	}
}
